<template>
  <div class="login-page">
    <div class="login-form" v-loading="loading">
      <div class="form-logo">
        <img src="~assets/logo-login.png" alt="">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text" v-model="account" name="" value="" placeholder="用户名">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password" @keyup.enter="login" v-model="password" name="" value="" placeholder="密码">
      </div>
      <div class="other-option">
        <div class="left-content">
          <img src="~assets/checked.png" alt="" v-if="checked" @click="checked=false">
          <img src="~assets/unchecked.png" class="unchecked-btn" alt="" v-if="!checked" @click="checked=true">
          <span>记住本电脑</span>
        </div>
<!--         <div class="right-content">
          <a href="javascript:;">登录</a><a>|</a><a @click="goRegister" href="javascript:;">注册</a>
        </div> -->
      </div>
      <a href="javascript:;" class="form-btn" @click="login">
        登 录
      </a>
    </div>
  </div>
</template>

<script>
  import {
    login
  } from '@/api/oli_api'

  export default {
    data () {
      return {
        loading: false,
        checked: true,
        account: '',
        password: ''
      }
    },
    created () {
      this.$store.dispatch('logOut')
    },
    methods: {
      login () {
        let vm = this
        if (!this.account) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提醒',
            message: '请输入账号'
          })
          return
        }
        if (!this.password) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提醒',
            message: '请输入密码'
          })
          return
        }
        vm.loading = true
        let parm = {
          USER_ACCOUNT: this.account,
          PWD: this.password
        }
        login(parm).then((data) => {
          if (data.code === 1) {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'success',
              title: '系统提醒',
              message: data.msg
            })
            vm.$store.dispatch('setLoginData', {data, save: vm.checked})
            vm.$router.push({name: vm.$store.getters.loginFor || 'index'})
          } else {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '系统提醒',
              message: data.msg
            })
          }
          vm.loading = false
        }).catch(function (e) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '登录失败',
            message: e
          })
          vm.loading = false
        })
      },
      goRegister () {
        this.$router.push('/register')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .login-page {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:url('~assets/login-bak.png');
    background-repeat: no-repeat;
    background-size: 100%, auto;
    .login-form {
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// login.vue?354634a6